import React, { useState, useEffect, useContext } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import moment from "moment";
import Skeleton from "react-loading-skeleton";

import { FiPlus } from "react-icons/fi";
import { BiEditAlt, BiCheck, BiTrash } from "react-icons/bi";
import { BsQuestionDiamond } from "react-icons/bs";

import {
	create_question,
	list_questions,
	remove_question,
	edit_questions,
} from "../../../services/questions";
import api from "../../../services/api";

import { QuestionType } from "../../../types/QuestionsTypes";

import Question from "../../../components/Question";

import { Container, Content } from "./styles";

import SessionContext from "../../../contexts/sessionContext";

function ChecklistAn() {
	const [baseQuestions, setBaseQuestions] = useState([]);
	const [questionsClone, setQuestionsClone] = useState<QuestionType[]>([]);
	const [editable, setEditable] = useState(false);
	const [confirm, setConfirm] = useState(false);
	const [isAllChecked, setIsAllChecked] = useState(false);
	const [selected, setSelected] = useState<any[]>([]);
	const [confirmRemove, setConfirmRemove] = useState(false);
	const [loading, setLoading] = useState(true);
	const [listDoc, setListDoc] = useState([]);
	const { user } = useContext(SessionContext);

	useEffect(() => {
		const list_doc = async () => {
			try {
				const { data } = await api.get("data/documentstags");
				const docs = data.data;

				if (docs) {
					setListDoc(docs);
				}
			} catch (error) {
				return error;
			}
		};

		list_doc();
	}, []);

	useEffect(
		() => setQuestionsClone(baseQuestions),
		[baseQuestions, editable],
	);

	useEffect(() => {
		const initiate_questions = async () => await request_questions();
		initiate_questions();
	}, []);

	const request_questions = async () => {
		setLoading(true);

		const quests = await list_questions(0);
		setBaseQuestions(quests.data);

		setLoading(false);
	};

	const handleAddQuestion = () => {
		setQuestionsClone([
			...questionsClone,
			{
				id: questionsClone.length,
				title: "",
				answers: [],
				checklist: 0,
				documents: [],
				createdAt: moment(Date.now()).format("DD MMM YYYY"),
				new: true,
			},
		]);
	};

	const handleSelectQuest = (id: number) => {
		if (selected.includes(id)) {
			let selected_clone = selected;
			selected_clone = selected_clone.slice(
				selected_clone.indexOf(id) + 1,
				1,
			);

			setSelected(selected_clone);
			return;
		}

		setSelected((selected: number[]) => [...selected, id]);
	};

	const handleSelectAll = (e: any) => {
		setIsAllChecked(!isAllChecked);
		setSelected(questionsClone.map((item) => item.id));
		if (isAllChecked) {
			setSelected([]);
		}
	};

	const Checkbox = ({ id, type, handleClick, isClicked }: any) => {
		return (
			<input
				id={id}
				type={type}
				onChange={handleClick}
				checked={isClicked}
			/>
		);
	};

	return (
		<Container>
			<div className='header'>
				<p id='func'>Administrador</p>
				<p id='name'>{user.name}</p>
			</div>

			<Content>
				<div className='check-form'>
					<div className='check-header'>
						<h2>Perguntas</h2>

						<div className='buttons'>
							<OutsideClickHandler
								onOutsideClick={() => setConfirmRemove(false)}>
								<button
									className={`remove ${
										selected.length > 0 || isAllChecked
											? "active"
											: "disabled"
									} ${
										confirmRemove &&
										(selected.length > 0 || isAllChecked)
											? "confirmation"
											: null
									}`}
									onClick={async () => {
										if (
											confirmRemove &&
											(selected.length > 0 ||
												isAllChecked)
										) {
											await remove_question(selected);

											setConfirmRemove(false);
											setSelected([]);

											request_questions();
										}

										setConfirmRemove(true);
									}}>
									{confirmRemove &&
									(selected.length > 0 || isAllChecked) ? (
										"Tem certeza?"
									) : (
										<BiTrash size={20} />
									)}
								</button>
							</OutsideClickHandler>

							<button
								className={`edit active ${
									editable ? "confirmation" : null
								}`}
								onClick={() => setEditable(!editable)}>
								{editable ? (
									"Cancelar"
								) : (
									<BiEditAlt size={20} />
								)}
							</button>

							<button
								className={`create ${
									editable ? "active" : null
								}`}
								onClick={
									editable ? handleAddQuestion : undefined
								}>
								<FiPlus size={20} />
							</button>

							<OutsideClickHandler
								onOutsideClick={() => setConfirm(false)}>
								<button
									className={`save ${
										editable ? "active" : "disabled"
									} ${confirm ? "confirmation" : null}`}
									onClick={async () => {
										if (confirm) {
											const edited_questions: QuestionType[] =
												[];
											const new_questions: QuestionType[] =
												[];

											questionsClone.map((question) => {
												if (question.edited){
													console.log('QUESTAO EDITADA', question);
													edited_questions.push(
														question,
													);}
												if (question.new){
													new_questions.push(
														question,
													);
												}
											});

											if (edited_questions)
												await edit_questions(
													edited_questions,
												);

											if (new_questions)
												await create_question(
													new_questions,
												);

											setConfirm(false);
											setEditable(false);

											request_questions();
										}

										if (editable) setConfirm(true);
									}}>
									{confirm ? (
										"Tem certeza?"
									) : (
										<BiCheck size={20} />
									)}
								</button>
							</OutsideClickHandler>
						</div>
					</div>

					<div className='questWrapper'>
						<table>
							<tr>
								<th>
									<Checkbox
										id='Select-all'
										name='selectAll'
										type='checkbox'
										handleClick={handleSelectAll}
										isClicked={isAllChecked}
									/>
								</th>

								<th>ID</th>
								<th>Data</th>
								<th className='title'>Titulo</th>
								<th>Respostas</th>
								<th>Sub-categorias</th>
								<th>Documentos</th>
							</tr>
							{loading ? (
								<tr>
									<td>
										<Skeleton height='2rem' width='100%' />
									</td>
									<td>
										<Skeleton height='2rem' width='100%' />
									</td>
									<td>
										<Skeleton height='2rem' width='100%' />
									</td>
									<td>
										<Skeleton height='2rem' width='100%' />
									</td>
									<td>
										<Skeleton height='2rem' width='100%' />
									</td>
									<td>
										<Skeleton height='2rem' width='100%' />
									</td>
									<td>
										<Skeleton height='2rem' width='100%' />
									</td>
								</tr>
							) : (
								questionsClone.map((question) => {
									return (
										<tr className='question-row'>
											<td>
												<Checkbox
													id={question.id}
													type='checkbox'
													handleClick={() =>
														handleSelectQuest(
															question.id!,
														)
													}
													isClicked={selected.includes(
														question.id!,
													)}
												/>
											</td>
											<td>{question.id}</td>
											<td>
												{moment(
													question.createdAt,
												).format("DD/MM/YYYY")}
											</td>
											<Question
												editable={editable}
												columns={[
													{
														type: "title",
														value: question.title,
													},
													{
														type: "answers",
														value: question.answers,
													},
													{
														type: "sub-categories",
														value: null,
													},
													{
														type: "sub-categories-documents",
														value: null,
													},
												]}
												current_question={question}
												setQuestions={setQuestionsClone}
												//@ts-ignore
												questionsClone={questionsClone}
												isNew={question?.new || false}
												listDoc={listDoc}
											/>
										</tr>
									);
								})
							)}
						</table>

						{!loading && !questionsClone.length ? (
							<div className='empty-table'>
								<BsQuestionDiamond
									id='question-icon'
									height={25}
								/>
								<p>Nenhuma questão cadastrada por aqui.</p>
							</div>
						) : null}
					</div>
				</div>
			</Content>
		</Container>
	);
}

export default ChecklistAn;
